// extracted by mini-css-extract-plugin
export default {"todoList":"TodoList_todoList__OLbJV","checked-item":"TodoList_checked-item__g1EEg","not-checked-item":"TodoList_not-checked-item__afb8R"};